<template> 
  <div class="tile is-parent is-12 metrics-grid">
    <div class="tile is-4 is-vertical is-child metrics-tile">
      <div class="mannequin">
        <div class="shape-image">
          <img :src="shapes[0].image" />
        </div>
      </div>
      <div id="chart1" class="chart">
        <D3PieChart :config="chart_config" :datum="chart_data[0]" />
      </div>
    </div>
    <div class="tile is-4 is-vertical is-child metrics-tile">
      <div class="mannequin">
        <div class="shape-image">
          <img :src="shapes[1].image" />
        </div>
      </div>
      <div id="chart2" class="chart">
        <D3PieChart :config="chart_config" :datum="chart_data[1]" />
      </div>
    </div>
    <div class="tile is-4 is-vertical is-child metrics-tile">
      <div class="mannequin">
        <div class="shape-image">
          <img :src="shapes[2].image" />
        </div>
      </div>
      <div id="chart3" class="chart">
        <D3PieChart :config="chart_config" :datum="chart_data[2]" />
      </div>
    </div>
    <div class="tile is-4 is-vertical is-child metrics-tile">
      <div class="mannequin">
        <div class="shape-image">
          <img :src="shapes[3].image" />
        </div>
      </div>
      <div id="chart4" class="chart">
        <D3PieChart :config="chart_config" :datum="chart_data[3]" />
      </div>
    </div>
    <div class="tile is-4 is-vertical is-child metrics-tile">
      <div class="mannequin">
        <div class="shape-image">
          <img :src="shapes[4].image" />
        </div>
      </div>
      <div id="chart5" class="chart">
        <D3PieChart :config="chart_config" :datum="chart_data[4]" />
      </div>
    </div>
    <div class="tile is-4 is-vertical is-child metrics-tile">
      <div class="mannequin">
        <div class="shape-image">
          <img :src="shapes[5].image" />
        </div>
      </div>
      <div id="chart6" class="chart">
        <D3PieChart :config="chart_config" :datum="chart_data[2]" />
      </div>
    </div>
  </div>
</template>

<script>
import { D3PieChart } from 'vue-d3-charts';
import Catalog from '@/services/catalog'

export default {
  name: "StyleAssortment",
  components: {
    D3PieChart
  },
  props: {
    collection: Object
  },
  data: function() {
    return {
      assortment: null,
      shapes: [
        {
          image: require('@/assets/images/pink_mannequin_1.png'),
        },
        {
          image: require('@/assets/images/pink_mannequin_2.png'),
        },
        {
          image: require('@/assets/images/pink_mannequin_3.png'),
        },
        {
          image: require('@/assets/images/pink_mannequin_1_3.png'),
        },
        {
          image: require('@/assets/images/pink_mannequin_2_3.png'),
        },
        {
          image: require('@/assets/images/pink_mannequin_3_plus.png'),
        }
      ],
      chart_data: [],
      chart_config: {
        key: "name",
        radius: {
          inner: 10,
          outter: false,
          padding: 0.25,
          round: 0,
        },
        value: "total",
        color: {
          key: 'color'
        },
        // color: {
        //   key: false,
        //   keys: false,
        //   scheme: "schemeTableau10",
        //   current: "#1f77b4",
        //   default: "#AAA",
        //   axis: "#000",
        // },
        // currentKey: false,
        // margin: {
        //   top: 20,
        //   right: 20,
        //   bottom: 20,
        //   left: 20,
        // },
        transition: {
          duration: 50,
          ease: "easeLinear",
        },
      }
    }
  },
  created: function() {
    // this.loadAssortment()
  },
  mounted: function() {
    this.loadAssortment()
  },
  methods: {
    loadAssortment() {
      var _this = this;
      Catalog.loadCollectionAssortment(this.collection)
        .then((response) => {
          response.forEach(element => {
            _this.chart_data.push([
              {
                name: 'Good',
                total: element[2] + element[3],
                color: 'green'
              },
              {
                name: 'Ok',
                total: element[0] + element[1],
                color: 'red'
              }
            ])
          });
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .metrics-grid {
    flex-wrap: wrap;
  }
  .metrics-tile {
    padding: 1em;
  }
  .mannequin { 
    padding: 2em;
    .shape-image {
      background-color: #d6d6d6;
      width: 15em;
    }
  }
  div.chart {
    padding-left: 0.1em;
    margin-left: 1em;
    width: 300px;
    height: 300px;
  }
</style>